import "./index.scss";

export const Splash1 = () => (
  <div
    style={{
      fontFamily: "initial",
      textShadow: "0 2px white",
      fontSize: "24px",
      lineHeight: "30px",
      fontWeight: "bold",
      color: "#b8bec5",
      margin: "calc((100vh - 30px) / 2) auto",
      display: "block",
      textAlign: "center",
    }}
  >
    {process.env.REACT_APP_TITLE}
  </div>
);

export const Splash2 = () => (
  <div className="splash2">
    <div className="self-building-square-spinner">
      <div className="square"></div>
      <div className="square"></div>
      <div className="square"></div>
      <div className="square clear"></div>
      <div className="square"></div>
      <div className="square"></div>
      <div className="square clear"></div>
      <div className="square"></div>
      <div className="square"></div>
    </div>
    <div className="init">初始化应用...</div>
  </div>
);
